import { render, staticRenderFns } from "./GiftEdit.vue?vue&type=template&id=337b6963&scoped=true&"
import script from "./GiftEdit.vue?vue&type=script&lang=js&"
export * from "./GiftEdit.vue?vue&type=script&lang=js&"
import style0 from "./GiftEdit.vue?vue&type=style&index=0&id=337b6963&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337b6963",
  null
  
)

export default component.exports